import Image from '@/components/UI/Image';
import { EFArrow } from '@/components/UI/svg/Search';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function ProductItem({ product, isMobile = false }: any) {
    const { Link, gloproductlist, useLang } = useGlobal();
    const { t } = useLang('shared');

    const getDataLayer = (name: string) => {
        return {
            event: 'uaEvent',
            event_name: 'select_search_result',
            list_name: 'Product',
            title_name: name,
            button_name: 'learn_more',
        };
    };

    // gloproductlist跳转处理
    let linkProps = {};
    if (product?.accessory) {
        linkProps = {
            href: product?.buyLink || '/',
        };
    } else {
        // river 2 max和river 2 pro 特殊处理 => 跳river 2页面
        if (['RIVER 2 Max', 'RIVER 2 Pro'].includes(product?.spuName)) {
            linkProps = {
                href: '/river-2-portable-power-station',
                as: '/river-2-portable-power-station',
            };
        } else {
            linkProps = {
                href:
                    `/${gloproductlist.find((item: any) => item?.type.toUpperCase() === 'PRODUCT' && item?.sourceId === product?.spuId)?.url}` ||
                    product?.buyLink ||
                    '/',
                // as:
                //     `/${gloproductlist.find((item: any) => item?.type.toUpperCase() === 'PRODUCT' && item?.sourceId === product?.spuId)?.url}` ||
                //     product?.buyLink ||
                //     '/',
            };
        }
    }

    let imagePath = '';
    try {
        const imageInfo = JSON.parse(product.images);
        imagePath = imageInfo.images || 'error';
    } catch {
        imagePath = product.images || 'error';
    }
    return (
        <div className={css.productItem}>
            <div className="productImg">
                <Image src={imagePath} preview={'false'} alt={product.spuName} fallback="/img/search/error.png" layout="fill" className="fullImgs" />
            </div>
            <div className="productInfo">
                <h3 style={{ fontWeight: 500 }}>{product.spuName}</h3>
                {!!product.description && <p>{product.description}</p>}
                <Link {...linkProps} ariaLabel={product.spuName} dataLayer={getDataLayer(product.spuName)}>
                    <span className="font-family-medium link" style={{ fontWeight: 400 }}>
                        {t('support.site_support_learn_more')}
                        <EFArrow />
                    </span>
                </Link>
            </div>
        </div>
    );
}
